import type { Preco, TabelaPreco } from '../db/tipos'
import { normalizarTexto } from '../lib/textoBR'

export type EstadoDoAdicionar = { pode: true } | { pode: false; motivo: string }

// Espelha o que montarLinhasPreco (pedidos/buscaPrecos.ts) deixa entrar na busca
// do pedido: produto ativo, preco vivo, tabela ativa e viva. Se a busca nao vai
// achar, o botao nao pode prometer.
export function estadoDoAdicionar(
  produto: { ativo: boolean },
  precosDoProduto: Preco[],
  tabelas: TabelaPreco[],
): EstadoDoAdicionar {
  if (!produto.ativo) return { pode: false, motivo: 'Produto inativo não entra em pedido.' }
  const ativas = new Set(tabelas.filter((t) => t.ativa && t.apagado_em === null).map((t) => t.id))
  const temPreco = precosDoProduto.some((p) => p.apagado_em === null && ativas.has(p.tabela_preco_id))
  if (!temPreco) {
    return { pode: false, motivo: 'Sem preço em nenhuma tabela ativa — lance um preço para poder vender.' }
  }
  return { pode: true }
}

// O nome da tabela aparece SO aqui, para o vendedor escolher consciente --
// nunca na mensagem ao cliente (decisao dela, 23/09).
export function opcoesDoCompartilhar(
  tabelaNome: string | null,
  precoAtual: Preco | undefined,
): { comPreco: { rotulo: string } | null; semPreco: { rotulo: string }; motivo: string | null } {
  const semPreco = { rotulo: 'Sem preço' }
  if (tabelaNome === null) {
    return { comPreco: null, semPreco, motivo: 'Escolha uma tabela para mandar com preço.' }
  }
  if (!precoAtual) {
    return { comPreco: null, semPreco, motivo: `Este produto não tem preço na tabela ${tabelaNome}.` }
  }
  return { comPreco: { rotulo: `Com preço · tabela ${tabelaNome}` }, semPreco, motivo: null }
}

// O que vai para ?busca= do pedido. A busca do pedido exige 2 letras: codigo
// de 1 letra ou vazio deixava o vendedor diante de uma busca vazia (minor 4 da
// revisao de 23/09) -- entao cai para a descricao.
export function termoDaBuscaDaFicha(produto: { codigo: string; descricao: string }): string {
  const codigo = produto.codigo.trim()
  return codigo.length >= 2 ? codigo : produto.descricao.trim()
}

// Busca de cliente do "+ Novo pedido": sem acento e sem maiuscula, a mesma
// normalizacao da busca da lista de pedidos (minor 5: "joao" nao achava "João").
export function clientesDaBuscaDaFicha<C extends { razao_social: string; nome_fantasia?: string | null }>(
  clientes: C[],
  termo: string,
  limite = 20,
): C[] {
  const t = normalizarTexto(termo)
  if (t.length < 2) return []
  return clientes
    .filter((c) => normalizarTexto(`${c.nome_fantasia ?? ''} ${c.razao_social}`).includes(t))
    .slice(0, limite)
}
